<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    custom-class="UpgradeDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('web4/icon-circle-fill')" />
          <span>提示</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <div class="text1" v-html="consumeInfo.title"></div>
        <div class="text2">{{ consumeInfo.content }}</div>
        <div class="text3">
          <svg-btn
            class="icon_checks"
            @click.prevent="chooseFile(checkedFiles)"
            :icon-class="
              checkedFiles
                ? 'icon-file-check'
                : 'icon-file-uncheck-' + $store.state.theme
            "
          ></svg-btn>
          今日不再提示
        </div>
      </div>
      <div class="d-footer">
        <fm-button type="primary" size="small" @click="okFn">确认</fm-button>
        <fm-button type="info" plain size="small" @click="handleClose"
          >取消</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "title",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    consumeInfo: {
      type: Object,
    },
  },
  watch: {
    isShow(val) {
      if (val) {
        this.checkedFiles = false;
      }
    },
  },
  data() {
    return {
      checkedFiles: false,
    };
  },
  methods: {
    chooseFile(type) {
      this.checkedFiles = !type;
    },
    okFn() {
      this.$emit("isok", this.checkedFiles, this.consumeInfo);
    },
    handleClose() {
      this.checkedFiles = false;
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.UpgradeDialog {
  .title {
    margin-top: 32px;
    margin-bottom: 12px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    span {
      color: #f67942;
    }
  }
  .txt {
    line-height: 22px;
    margin-bottom: 24px;
    text-align: center;
  }

  .d-content {
    text-align: center;
    margin: 30px 0 24px 0;
    .text1 {
      height: 24px;
      font-weight: 400;
      font-size: 16px;
      @include useTheme {
        color: getVar("text-color2-2c2c2c");
      }
      line-height: 24px;

      span {
        color: #f67942;
      }
    }
    .text2 {
      margin-top: 12px;
      height: 22px;
      font-weight: 400;
      font-size: 14px;
      @include useTheme {
        color: getVar("text-color2-2c2c2c");
      }
      line-height: 22px;
    }
    .text3 {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 22px;
      font-weight: 400;
      font-size: 14px;
      @include useTheme {
        color: getVar("text-color2-2c2c2c");
      }
      line-height: 22px;
      margin-top: 16px;
      user-select: none;
      -webkit-user-select: none; /* Safari */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* IE10+/Edge */
      .icon_checks {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        cursor: pointer;
      }
    }
  }

  .d-footer {
    display: flex;
    justify-content: flex-end;
    .btnClass {
      width: 120px;
      height: 36px;
      border-radius: 18px;
      margin-right: 20px;
      &:last-child {
        margin-left: 0px;
        margin-right: 0px;
      }
    }
  }
}
</style>